<template>
    <div class="col">
        <div class="row justify-content-center mt-3">
            <div class="col">
                <h3 class="text-center">Voting for adding treatment</h3>
                <p class="text-center">in {{detail.branch.name}}</p>
            </div>
        </div>

        <div class="row justify-content-center mt-3">
            <div class="col">
                <h3 class="text-center">Treatment</h3>
            </div>
        </div>

        <div class="row justify-content-center">
            <div class="col-6 text-right">Name:</div>
            <div class="col-6">{{detail.name}}</div>
        </div>
    </div>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from "vue-property-decorator";
    import {ToolVotingDetail} from "@/entities/voting/ToolVotingDetail";

    @Component
    export default class ToolVotingDetailView extends Vue{
        @Prop()
        detail!: ToolVotingDetail;
    }
</script>

<style scoped>
</style>
